<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <template v-if="isQuoteField">
    <jw-input-number :precision="getPrecision(modulesItem, precisionNum, true)" v-model="modulesItem.fieldValue" class="system-form-item-fields computed-fields ly-form-item-fields-disabled" :placeholder="quoteFieldPlaceholder" hide-button disabled>
      <template #suffix> % </template>
    </jw-input-number>
  </template>

  <template v-else-if="modulesItem?.setting?.fieldKey !== 'taxRate'">
    <template v-if="isFormat">
      <!--  精度 末尾不省略0 -->
      <jw-input-number ref="inputNumberRef" v-model="modulesItem.fieldValue" class="system-form-item-fields" :placeholder="modulesItem?.placeholder || ''" @blur="handleChange" @clear="handleChange" allow-clear hide-button :disabled="modulesItem.businessData == '0' || disabledAll" @focus="clearUploadActive" @input="(event) => getPrecisionNum(event, modulesItem)" :precision="tools.isJSON(modulesItem?.setting?.fieldExt) ? Number(JSON.parse(modulesItem?.setting?.fieldExt)?.numberFormat) : 2">
        <template #suffix> % </template>
      </jw-input-number>
    </template>
    <template v-else>
      <!-- 精度 末尾省略0 -->
      <jw-input-number v-model="modulesItem.fieldValue" class="system-form-item-fields" :placeholder="modulesItem?.placeholder || ''" @focus="handleFocus" allow-clear hide-button :disabled="modulesItem.businessData == '0' || disabledAll" :precision="getPrecision(modulesItem, precisionNum)">
        <template #suffix> % </template>
      </jw-input-number>
    </template>
  </template>
  <template v-else>
    <jw-input-number v-model="modulesItem.fieldValue" class="system-form-item-fields" :placeholder="modulesItem?.placeholder || ''" hide-button disabled @input="(event) => getPrecisionNum(event, modulesItem)" :precision="getPrecision(modulesItem, precisionNum)">
      <template #suffix> % </template>
    </jw-input-number>
  </template>
</template>

<script setup>
import { ref, nextTick, inject } from 'vue';
import { useUploadStore } from '@/store';

const uploadStore = useUploadStore();
// 精度
import useThousandOption from '@/hooks/thousand';
import { tools } from '@/utils/tools';
const isQuoteField = inject('fhFormFieldsParams')?.isQuoteField;
const quoteFieldPlaceholder = inject('fhFormFieldsParams')?.quoteFieldPlaceholder;
// 处理精度 千分符
const { precisionNum, getPrecisionNum, getPrecision } = useThousandOption();
const emits = defineEmits(['cb']);

const props = defineProps({
  modules: {
    type: Object,
    default: () => {}
  },
  disabledAll: {
    type: Boolean,
    default: false
  }
});

const isFormat = ref(false);
const inputNumberRef = ref();
// const isQuoteCmpPercent = computed(() => {
//   return props.modules?.setting?.business?.fieldType === 24;
// });
const clearUploadActive = () => {
  uploadStore.clearActive();
};
const handleFocus = () => {
  isFormat.value = true;
  nextTick(() => {
    inputNumberRef.value?.focus();
  });
  clearUploadActive();
};

const modulesItem = ref(props?.modules);
const handleChange = async () => {
  await nextTick();
  emits('cb', modulesItem.value);
};
</script>
